export default "__VITE_ASSET__3GjyipzD__"